import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable
react/jsx-one-expression-per-line,
react/jsx-closing-tag-location,
react/jsx-indent,
react/jsx-indent-props */
import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Box, Chip, Typography } from '@mui/material';
import { useStore } from '@mcn-platform/models';
import { applyThemeColor } from '@mcn-platform/converse-lib';
const getQuizName = (course, sectionID) => {
    try {
        const quizSection = course?.getQuizSectionById(sectionID);
        return quizSection?.name || 'Deleted';
    }
    catch {
        return 'Deleted';
    }
};
const ShowQuestionWithAnswers = ({ question, index, isCorrect, userAnswers, inputValue, }) => (_jsxs(_Fragment, { children: [question?.type === 'multipleChoiceQuestion' && (_jsxs(Box, { sx: { mb: 2 }, children: [_jsxs(Box, { sx: { display: 'flex' }, children: [_jsxs(Typography, { variant: "h6", children: ["[Multiple Choice] Question ", index, ": ", question.questionText] }), _jsx(Typography, { sx: {
                                color: isCorrect ? 'green' : 'red',
                                fontWeight: 'bold',
                                ml: '10px',
                            }, children: isCorrect ? '✓ Correct' : '✗ Incorrect' })] }), question.answers.map((answer) => {
                    const isSelected = userAnswers?.includes(answer.id);
                    const isAnswerCorrect = question?.correctAnswer?.includes(answer.id);
                    return (_jsx(Box, { sx: {
                            display: 'flex',
                            alignItems: 'center',
                            border: isSelected ? `2px solid ${isAnswerCorrect ? 'green' : 'red'}` : 'none',
                            borderRadius: '5px',
                            padding: '5px',
                        }, children: _jsxs(Typography, { sx: {
                                color: isAnswerCorrect ? 'green' : 'red',
                                fontWeight: 'bold',
                            }, children: [isAnswerCorrect ? '✓ ' : '✗ ', answer.answerText] }) }, answer.id));
                })] })), question?.type === 'fillInTheBlank' && (_jsxs(Box, { sx: { mb: 2 }, children: [_jsxs(Typography, { variant: "h6", children: ["[Fill in the Blank] Question ", index, ": ", question.questionText] }), _jsxs(Typography, { sx: { color: isCorrect ? 'green' : 'red', fontWeight: 'bold' }, children: ["Answer: ", inputValue || 'No answer provided', " ", isCorrect ? '✓' : '✗'] })] })), question?.type === 'openEnded' && (_jsxs(Box, { sx: { mb: 2 }, children: [_jsxs(Typography, { variant: "h6", children: ["[Open Ended] Question ", index, ": ", question.questionText] }), _jsxs(Typography, { sx: { fontWeight: 'bold' }, children: ["Answer: ", inputValue || 'No answer provided'] })] }))] }));
const QuizHeader = ({ quizName, score, isPassed, completedAt, }) => (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "h4", sx: { mt: 2 }, children: quizName || 'Deleted Quiz' }), _jsxs(Typography, { variant: "h6", children: ["Completed At: ", completedAt ? new Date(completedAt).toLocaleString() : 'N/A'] }), _jsxs(Typography, { variant: "h6", sx: { mb: 2 }, children: ["Score:", ' ', _jsxs("span", { style: { color: isPassed ? 'green' : 'red' }, children: [score ?? 0, "%"] }), _jsx(Chip, { label: isPassed ? 'Passed' : 'Failed', sx: {
                        ml: '10px',
                        backgroundColor: isPassed ? 'green' : 'red',
                        color: 'white',
                    } })] })] }));
const ShowResults = ({ course, results, sectionID }) => results?.map(({ inputValue, isCorrect, question: questionId, userAnswers, }, index) => {
    let question;
    try {
        question = course.getQuestionById(sectionID, questionId);
    }
    catch {
        const quizResult = course?.item?.quizResults?.[sectionID];
        const historyAnswers = quizResult?.history?.[0]?.answers;
        const allAnswers = (historyAnswers?.correct || []).concat(historyAnswers?.incorrect || []);
        question = allAnswers.find((q) => q.id === questionId);
    }
    if (!question)
        return null;
    return (_jsx(Box, { children: _jsx(ShowQuestionWithAnswers, { question: question, index: index + 1, isCorrect: isCorrect, inputValue: inputValue, userAnswers: userAnswers }) }, question?.id || `${index}-${questionId}`));
});
const MyResults = observer(() => {
    const store = useStore();
    const { currentPortal } = useStore();
    const [results, setResults] = useState([]);
    const colorScheme = currentPortal?.stylesheet;
    useEffect(() => {
        const courseProgresses = store.currentCourseProgresses || [];
        setResults(courseProgresses);
    }, [store.currentCourseProgresses]);
    return (_jsxs(Box, { sx: {
            width: '100%',
            maxWidth: 1200,
            marginX: 'auto',
            padding: 4,
        }, children: [_jsx(Typography, { variant: "h3", sx: { mb: 3 }, children: "My Quiz Results" }), results.length === 0 ? (_jsx(Typography, { variant: "body1", color: "text.secondary", children: "No quiz results available." })) : (results.map((item) => (_jsx(Box, { sx: {
                    mb: 4,
                    p: 2,
                    border: '1px solid #ccc',
                    borderRadius: 2,
                    color: applyThemeColor(colorScheme, colorScheme.global?.font?.color),
                    backgroundColor: applyThemeColor(colorScheme, colorScheme.global?.background?.color),
                }, children: item?.quizResults
                    && Object.entries(item.quizResults).map(([key, quizResult]) => {
                        const quizName = getQuizName(item?.course, key);
                        return (_jsxs(React.Fragment, { children: [quizResult.isCompleted ? (_jsx(QuizHeader, { quizName: quizName, score: quizResult?.score ?? 0, isPassed: quizResult?.isPassed ?? false, completedAt: quizResult?.completedAt })) : (_jsxs(_Fragment, { children: [_jsxs(Typography, { variant: "h5", sx: { my: 2 }, children: ["Started But Not Completed \u2014 ", quizResult.startedAt] }), _jsx(Chip, { label: "Not Completed", sx: {
                                                backgroundColor: 'orange',
                                                color: 'white',
                                            } })] })), _jsx(ShowResults, { sectionID: key, results: quizResult.results, course: item?.course })] }, key));
                    }) }, item.id || item.course?.id))))] }));
});
export default MyResults;
//# sourceMappingURL=MyResults.js.map